module.exports = __webpack_public_path__ + "img/head.80fb320c.png";